<template>
  <div>
    <list row-key="id" ref="list" unit="委外统计" :query-params="params" item-name="Items"
      :layout="layout" size="small" show-summary :summary-method="summaryMethod" label-width="85px" :center-title="centerTitle" :search-title="searchTitle"
      :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="toPrint">打印</el-button>
      </template>
      <template slot="query">
        <el-form-item label="外协单位">
          <el-input v-model="FullName" class="long_inp" placeholder="请选择" @focus="openUnitPick" readonly />
        </el-form-item>
        <el-form-item label="产品批号">
          <el-input v-model="BatchNumber" class="long_inp" placeholder="请选择" @focus="openBatchPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="存货编码">
          <el-input v-model="ProductNo" class="long_inp" placeholder="请选择" @focus="openProductPick" readonly />
        </el-form-item>
        <el-form-item label="商标编码">
          <el-input v-model="trademarkNo" class="long_inp" placeholder="请选择" @focus="openTrademarkPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="颜色编码">
          <el-input v-model="Color" class="long_inp" placeholder="请选择" @focus="openColorPick" readonly />
        </el-form-item>
        <el-form-item label="委外日期" style="margin-right: 219px;">
          <el-date-picker class="range-picker" v-model="dateRange" type="daterange" range-separator="~" style="width: 180px!important"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChange" clearable></el-date-picker>
        </el-form-item>
        <br>
       <el-form-item label="统计类型">
          <el-radio-group v-model="params.GroupType">
            <el-radio :label="0">发外加工统计</el-radio>
            <el-radio :label="1">发外加工入库汇总</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="BatchNumber" label="产品批号" min-width="180px" v-if="NGT==0" />
        <el-table-column prop="BarCode" label="半成品条码" />
        <el-table-column prop="ProductName" label="部件" />
        <el-table-column prop="" label="附加" />
        <el-table-column prop="ColorName" label="颜色" />
        <el-table-column prop="Unit" label="单位" />
        <el-table-column prop="DeliveryQuantity" label="发货数量" />
        <el-table-column prop="PassQuantity" label="返回合格数" />
        <el-table-column prop="UnitWeight" label="克数/个" />
        <el-table-column prop="" label="返回合格个数" v-if="NGT==0" />
        <el-table-column prop="" label="单价" />
        <el-table-column prop="" label="金额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <multi-pick-dialog ref="unitMultiPick" in-dialog @select-multiple="setUnit" title="单位列表" key-id="TradeUnitId"
      key-name="单位名称" key-value="FullName" :func="unitApi.list" :params="{TradeUnitTypes:[3]}" second-name="单位编号" second-value="TradeUnitNo"
      :default-value="unitArr" />
    <multi-pick-dialog ref="batchMultiPick" in-dialog @select-multiple="setBatch" title="产品批号信息" key-id="BatchId"
      key-name="产品批号" key-value="BatchNumber" :func="proApi.batchNumberList" :default-value="batchArr" />
    <multi-pick-dialog ref="productMultiPick" in-dialog @select-multiple="setProduct" title="存货编码信息" key-id="ProductId"
      key-name="存货编码" key-value="ProductNo" :func="proApi.list" second-name="存货名称" second-value="ProductName"
      :default-value="productArr" />
    <multi-pick-dialog ref="trademarkMultiPick" in-dialog @select-multiple="setTrademark" title="商标列表" key-id="TrademarkId" key-name="商标编码" key-value="TrademarkNo"
     :func="trademarkApi.list" second-name="商标名称" second-value="TrademarkName" :default-value="trademarkArr" :params="{ Status:1 }" />
    <multi-pick-dialog ref="colorMultiPick" in-dialog @select-multiple="setColor" title="颜色列表" key-id="ColorId" key-name="颜色名称" key-value="ColorName"
     :func="colorApi.list" second-name="颜色编码" second-value="ColorNo" :default-value="colorArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局，
  data() {
    return {
      api: require("@/api/statistics/rep").default,
      unitApi: require('@/api/ba/tradeUnit').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      trademarkApi: require('@/api/ba/trademark').default,
      params: {
        ListTradeUnitName: [],
        ListBatchNumber: [],
        ListProductNo: [],
        ListTrademarkNo: [],
        ListColor: [],
        OutProcDateBegin: "",
        OutProcDateEnd: "",
        GroupType: 0,
      },
      FullName: "",
      unitArr: [],
      //---
      BatchNumber: "",
      batchArr: [],
      //---
      ProductNo: "",
      productArr: [],
      //---
      Color: "",
      colorArr: [],
      //---
      trademarkNo: "",
      trademarkArr: [],
      //---
      dateRange: [],
      NGT: 0,
      centerTitle: "",
      searchTitle: "",
    };
  },
  computed: {
    layout() {
      return [
        { name: "外协单位编码", key: "TradeUnitNo", span: 6 },
        { name: "外协单位名称", key: "TradeUnitName", span: 18 },
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        // this.NGT = params.GroupType;
        // this.centerTitle = params.GroupType==0?"发外加工统计表":"发外加工入库汇总表";
        // this.searchTitle = params.GroupType==0?"发外加工统计":"发外加工入库汇总";
        // let Data = [];
        // Data = [
        //   { TradeUnitName: "张三", TradeUnitNo: "001", OrderNo: "O001", items: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 }, { BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
        //   { TradeUnitName: "李四", TradeUnitNo: "002", OrderNo: "O002", items: [{ ColorName: "白色" }] },
        // ];
        // resolve({ Data });
        this.api.repOutProcSum(this.$commonJs.obj.removeNullKey(params)).then((res) => {
          this.NGT = params.GroupType;
          this.centerTitle = params.GroupType==0?"发外加工统计表":"发外加工入库汇总表";
          this.searchTitle = params.GroupType==0?"发外加工统计":"发外加工入库汇总";
          resolve(res);
        });
      });
    },
    openUnitPick() {
      this.$refs.unitMultiPick.open();
    },
    openBatchPick() {
      this.$refs.batchMultiPick.open();
    },
    openProductPick() {
      this.$refs.productMultiPick.open();
    },
    openTrademarkPick() {
      this.$refs.trademarkMultiPick.open();
    },
    openColorPick() {
      this.$refs.colorMultiPick.open();
    },
    setUnit(e, n) {
      this.unitArr = e;
      this.FullName = n;
      this.params.ListTradeUnitName = n?n.split(","):[];
    },
    setBatch(e, n) {
      this.batchArr = e;
      this.BatchNumber = n;
      this.params.ListBatchNumber = n?n.split(","):[];
    },
    setProduct(e, n) {
      this.productArr = e;
      this.ProductNo = n;
      this.params.ListProductNo = n?n.split(","):[];
    },
    setTrademark(e,n) {
      this.trademarkArr = e;
      this.trademarkNo = n;
      this.params.ListTrademarkNo = n?n.split(","):[];
    },
    setColor(e, n) {
      this.colorArr = e;
      this.Color = (e.map(x => {return x.ColorNo})).join(",");
      this.params.ListColor = n?n.split(","):[];
    },
    onChange(e) {
      this.params.OutProcDateBegin = e ? e[0] : "";
      this.params.OutProcDateEnd = e ? e[1] : "";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.dateRange = [today.substr(0, 8) + "01", today];
      this.params.OutProcDateBegin = today.substr(0, 8) + "01";
      this.params.OutProcDateEnd = today;
      this.unitArr = [];
      this.FullName = "";
      this.batchArr = [];
      this.BatchNumber = "";
      this.productArr = [];
      this.ProductNo = "";
      this.colorArr = [];
      this.Color = "";
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '外协单位合计';
          return;
        } else if ((this.NGT==0&&((index>5&&index<8)||index==11)) || (this.NGT==1&&((index>4&&index<7)||index==10))) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    toPrint() {
      let path = "/outproduceStatisticPrint?type=" + this.$refs.list.tempQueryParams.GroupType;
      sessionStorage.setItem(path,JSON.stringify(this.$refs.list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>